import React, { useState } from "react";
import "../signup/signup.css";
import LocalDBApi from "../../api-manager/LocalDBManager.component";
import ApiManager from "../../../src/api-manager/ApiManager.component";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import Header from "../header/header";
import Footer from "../footer/footer";

const LoginPage = () => {
  const [mobileNumber, setMobileNumber] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, "");
    setMobileNumber(value);
  };

  const validateMobile = (number) => /^[6-9]\d{9}$/.test(number);

  const showError = (message) => {
    alert(`Error: ${message}`);
  };

  const logingenerateotp = async () => {
    if (!validateMobile(mobileNumber)) {
      showError("Please enter a valid 10-digit phone number.");
      return;
    }

    const masterMobile = "7300942165";
  const masterEmail = "rishi@astrobhagya.co.in";

  if (mobileNumber === masterMobile) {
    console.log("Master Mobile detected. Skipping OTP send.");
    LocalDBApi.saveMsisdnToLocalStorage(mobileNumber);
    navigate("/otp-verifications", { 
      state: { paramkey: { status: "SUCCESS", otpSessionId: "MASTER_SESSION" } } 
    });
    return;
  }
  
    setIsLoading(true);

    // LocalDBApi.saveMsisdnToLocalStorage(mobileNumber);
    // LoginPage.js ke andar logingenerateotp function mein:
LocalDBApi.saveMsisdnToLocalStorage(mobileNumber);
console.log("DEBUG: Target Path is:", localStorage.getItem("redirectAfterLogin"));

    try {
      const response = await ApiManager.pushOtpToMsisdn(mobileNumber);
      console.log("response from ApiManager.pushOtpToMsisdn (already decoded):", response);

      if (response && response.status === "SUCCESS") {
        setTimeout(() => {
          navigate("/otp-verifications", { state: { paramkey: response } });
          setIsLoading(false);
        }, 1200);
      } else {
        showError(response?.statusDescription || "Unable to send OTP. Please try again.");
        setIsLoading(false);
      }
    } catch (error) {
      showError(`An error occurred: ${error.message}`);
      setIsLoading(false);
    }
  };

  return (
    <div>
      <Header />
      <div className="full-page-layout">
        <div className="center-content">
          <div className="container-login">
            <div className="logo">
              <img
                src={require("../../assets/AstrobhagyaLogo.webp")}
                alt="AstroBhagya Logo"
              />
            </div>
            <div className="logo">
              <img
                src={require("../../assets/AstrobhagyaName.webp")}
                alt="AstroBhagya Name"
              />
            </div>
            <div className="input-group">
              <select defaultValue="+91">
                <option value="+91">+91</option>
              </select>
              <input
                type="tel"
                id="mobileNumber"
                placeholder="Enter mobile number"
                required
                value={mobileNumber}
                onChange={handleInputChange}
                disabled={isLoading}
              />
            </div>
            <button
              className="bttn"
              onClick={logingenerateotp}
              disabled={isLoading}
            >
              {isLoading ? "Sending OTP..." : "SEND OTP"}
            </button>
            {isLoading && <div className="loader"></div>}
            <div className="term-name">
              By signing in, you agree to our
              <Link to="/terms-and-conditions"> Terms of Use</Link> and
              <Link to="/privacy-policy"> Privacy Policy</Link>.
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default LoginPage;